import { object } from 'prop-types';
import { CHARGING_STATES } from '../Constants';
import { useTranslation } from 'react-i18next';

import { humanizeTotalTimeElapsed } from '../Utils/charging-point';

export const sortByStatus = (
  connectorsArr,
  statusOrder = ['Available', 'Charging', 'Finishing', 'SuspendedEV', 'Preparing', 'Offline']
) => {
  return connectorsArr.sort(
    (a, b) => statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status)
  );
};

export const unwindConnectors = (chargingPoints) => {
  // if single object then convert to an array before the unwind process
  const _chargingPoints =
    !Array.isArray(chargingPoints) && typeof chargingPoints === 'object' && object !== null
      ? [chargingPoints]
      : chargingPoints;

  return _chargingPoints.reduce((acc, current) => {
    const { chargePointConnectors, ...chargingPoint } = current;
    chargePointConnectors?.forEach((connector) => {
      acc.push({ ...connector, chargingPoint });
    });
    return acc;
  }, []);
};

export const getStatusClassName = ({ status, className }) =>
  status
    ? { className: className.concat(` ${className}--${status.toLowerCase()}`) }
    : { className };

export const getControlButtonProps = ({ status, isLoading, hasStopAccess, isSession }) => {
  console.log('getControlButtonProps: Status', status);
  console.log('getControlButtonProps: isLoading', isLoading);
  console.log('getControlButtonProps: hasStopAccess', hasStopAccess);
  console.log('getControlButtonProps: isSession', isSession);
  const { t } = useTranslation();
  if (status === CHARGING_STATES.PREPARING && isSession) {
    return {
      label: t('begin_charging'),
      isLoading: true,
      disabled: isLoading,
      className: 'button__alfa'
    };
  } else if (status === CHARGING_STATES.PREPARING) {
    return {
      label: t('begin_charging'),
      disabled: isLoading,
      isLoading,
      className: 'button__alfa'
    };
  } else if (status === CHARGING_STATES.CHARGING) {
    return {
      label: t('stop_charging'),
      disabled: isLoading || !hasStopAccess,
      isLoading,
      className: 'button__bravo'
    };
  } else {
    return { hide: true };
  }
};

export const extractEnergyValuesFromConnector = (connector) => {
  // Add null check for connector
  if (!connector) {
    return {
      totalEnergyWh: 0,
      powerActiveImportEnergy: 0,
      totalTimeElapsed: 0,
      currentSession: null
    };
  }

  const {
    sessions = [],
    // connector-level realtime fields (from websocket)
    totalEnergyWh: connectorEnergyWh,
    powerActiveImportEnergy: connectorPowerActiveImportEnergy,
    totalTimeElapsed: connectorTimeElapsed
  } = connector;
  const targetSession = Array.isArray(sessions) ? sessions[sessions.length - 1] : sessions;

  // Get current session
  const currentSession = targetSession;

  
  // Fallback: read from session-level fields
  return {
    totalEnergyWh: connectorEnergyWh ?? currentSession?.totalEnergyConsumed ?? 0,
    powerActiveImportEnergy: connectorPowerActiveImportEnergy ?? currentSession?.powerActiveImportValue ?? 0,
    totalTimeElapsed: connectorTimeElapsed ?? currentSession?.totalTimeElapsed ?? 0,
    currentSession
  };
};

export const getConnectorDetails = (connector) => {
  const { t } = useTranslation();
  const {
    status,
    chargingPoint: {
      chargePointConfiguration: { powerType, wattsAuthorize, currency } = {},
      prices = []
    } = {}
  } = connector;

  const { totalEnergyWh, powerActiveImportEnergy, totalTimeElapsed, currentSession } =
    extractEnergyValuesFromConnector(connector);
  const price = prices.length > 0 ? prices[prices.length - 1].price : null;
  if (
    status === CHARGING_STATES.CHARGING ||
    status === CHARGING_STATES.FINISHING ||
    status === CHARGING_STATES.COMPLETED
  ) {
    const valueClass = 'value__charging';
    return [
      {
        label: t('total_charged'),
        value: `${(totalEnergyWh / 1000).toFixed(2)} kWh`,
        valueClass
      },
      {
        label: t('power'),
        value: `${(powerActiveImportEnergy / 1000).toFixed(2)} kW`,
        valueClass
      },
      {
        label: t('total_time'),
        // Use totalTimeElapsed from session if available, otherwise calculate from createdAt
        value: totalTimeElapsed
          ? humanizeTotalTimeElapsed(totalTimeElapsed)
          : currentSession?.createdAt
            ? humanizeTotalTimeElapsed(new Date() - new Date(currentSession.createdAt))
            : '0',
        valueClass
      }
    ];
  } else {
    const valueClass = status !== CHARGING_STATES.OFFLINE ? 'value__ready' : '';
    return [
      {
        label: t('power_type'),
        value: powerType || '-',
        valueClass
      },
      {
        label: t('max_power'),
        value: wattsAuthorize ? `${wattsAuthorize / 1000}kW` : '-',
        valueClass
      },
      {
        label: t('price'),
        value: price ? `${parseFloat(price) / 100} ${currency}/kW` : '-',
        valueClass
      }
    ];
  }
};
